import { useNavigate } from "react-router-dom";
import { getReviewArticle } from "./_request";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const TazakuraatReview = () => {
    const navigate = useNavigate();
    const { authToken } = useAuth();
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(false); // Track loading state
    useEffect(() => {
    const fetchArticles = async () => {
        setLoading(true);
        try {
            const response = await getReviewArticle(authToken);
            if (response.Result) {
                const data = response.Articles;
                setArticles(data);
            } else {
                console.error(response.Msg);
            }
        } catch (error) {
            console.error("Error fetching articles:", error);
        } finally {
            setLoading(false);
        }
    };

    fetchArticles();
}, [authToken]);


const handleEditClick = (articleId) => {
    navigate('/tazakraatreview/reviewArticle', { state: { articleId } });
};


    return (
        <>
            <div className="container mx-auto p-4">
                {/* Header with Heading and Button */}
                <div className="flex justify-between items-center mb-4">
                    <h1 className="font-bold text-3xl">Tazakuraat Review</h1>
                    
                </div>

                {/* Articles Table */}
                <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '16px' }}><CircularProgress /></div>
                    ) : (
                        <table className="min-w-full table-auto">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="py-3 px-4 text-left font-semibold">ID</th>
                                    <th className="py-3 px-4 text-left font-semibold">Title</th>
                                    <th className="py-3 px-4 text-left font-semibold">Category</th>
                                    <th className="py-3 px-4 text-left font-semibold">Type</th>
                                    <th className="py-3 px-4 text-left font-semibold">Read Time</th>
                                    <th className="py-3 px-4 text-left font-semibold">Status</th>
                                    <th className="py-3 px-4 text-left font-semibold">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {articles.map((article) => (
                                    <tr key={article.id} className="border-b hover:bg-gray-50">
                                        <td className="py-3 px-4">{article.id}</td>
                                        <td className="py-3 px-4">{article.title}</td>
                                        <td className="py-3 px-4">{article.category}</td>
                                        <td className="py-3 px-4">{article.article_type}</td>
                                        <td className="py-3 px-4">{article.read_min} Min</td>
                                        <td className="py-3 px-4">{article.status}</td>

                                        <td className="py-3 px-4 flex gap-3 w-fit">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => handleEditClick(article.id)}
                                                disabled={loading}
                                            >
                                                Review
                                            </Button>
                                            
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    );
};


export default TazakuraatReview